import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "./AuthProvider";

// SPEC-009 §4.3: protected routes redirect to /login when the auth context
// reports anon. Loading state shows nothing (the auth check is fast) to
// avoid a flash of the login screen on every refresh.
export function RequireAuth({ children }: { children: React.ReactNode }) {
  const { status } = useAuth();
  const loc = useLocation();
  if (status === "loading") return null;
  if (status === "anon") {
    return <Navigate to="/login" replace state={{ from: loc.pathname }} />;
  }
  return <>{children}</>;
}
